import { connect } from 'react-redux';
import { externalLoginAction, authorizeAction } from '../reducers/auth.reducers';
import { navigate } from '../reducers/navigator.reducers';
import Login from './login';

const mapDispatchToProps = dispatch => ({
  login: loginDto => dispatch(externalLoginAction(loginDto)),
  authorize: dto => dispatch(authorizeAction(dto)),
  navigate: route => dispatch(navigate({ route })),
});

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
  accessToken: state.authentication.accessToken,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/app/external_login/login.container.js